export const PROJECTS = [
  {
    id: 0,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/05/IMG_5884-370x250.jpg",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 1,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/04/Richards_Studio_D4905978.png",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 2,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/03/IMG_1185001.png",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 3,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/02/Nuvia-and-Ted-Perkins-370x250.jpg",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 4,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/01/DSC09960WEB-370x250.jpg",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 5,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/01/DSCF70671920x1600WebBlog-370x250.jpg",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 6,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2017/12/20171214-Margrett-Groves-370x250.jpg",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 7,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/01/Butterfly-Challenge-1-Compressed-370x250.jpg",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  },
  {
    id: 8,
    title: "GUGO - REI",
    image:
      "https://unionclubtacoma.com/wp-content/uploads/2018/01/Eli-Moreno-Youtube-Screenshot-Compressed-370x250.jpg",
    description: "Gear Up Get Out",
    url: "https://www.google.com"
  }
];
